const VISIBLE_PHONE_NUMBER_CHARS = 8;
const MIN_DIGITS_TO_CONSIDER_PHONE = 7;

// Masks everything after the first few characters, keeping the asterisk
// count equal to the hidden characters, e.g. +6281311240587 -> +6281311******
export const maskPhoneNumber = value => {
  if (!value) return '';
  const phone = String(value).trim();
  if (phone.length <= VISIBLE_PHONE_NUMBER_CHARS) return phone;

  const maskedLength = phone.length - VISIBLE_PHONE_NUMBER_CHARS;
  return `${phone.slice(0, VISIBLE_PHONE_NUMBER_CHARS)}${'*'.repeat(
    maskedLength
  )}`;
};

export const looksLikePhoneNumber = value => {
  if (!value) return false;
  const candidate = String(value).trim();
  if (!/^\+?[0-9\s\-().]+$/.test(candidate)) return false;

  const digitCount = (candidate.match(/\d/g) || []).length;
  return digitCount >= MIN_DIGITS_TO_CONSIDER_PHONE;
};

// Contact names created from a phone number (common on WhatsApp/SMS inboxes)
// should be masked the same way as the phone number field itself.
export const maskIfPhoneNumber = value =>
  looksLikePhoneNumber(value) ? maskPhoneNumber(value) : value;
